import { useContext, useState } from 'react';
import { useCallback } from 'react';
import { HimmaContext } from '../context/HimmaContext';
import { AddReviewRequest, DeleteReviewsRequest, ToggleReviewApprovalStatusRequest } from '../client-sdk';


export const useItemReviewApi = () => {
  const api = useContext(HimmaContext)!;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const getAllItemReview = useCallback(
    async (query: any) => {
      setLoading(true);
      setError(null);
      try {
        // Only include search parameter if it has a value
        const searchParam =
          query.search && query.search.trim() !== '' ? query.search : undefined;
        const response = await api.getAllReviews(
          query.type,
          query.page,
          query.limit,
          query.storeId,
          query.merchantId,
          searchParam,
          query.status,
          query.sortBy,
          query.sortDirection,
       );
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  const getToggleStatus = useCallback(
    async (query: any) => {
      setLoading(true);
      setError(null);
      try {
        const toggleReviewRequest: ToggleReviewApprovalStatusRequest = {
          reviewIds: Array.isArray(query.id) ? query.id : [query.id],
          status: query.status,
        };
        const response = await api.toggleReviewApprovalStatus(
          toggleReviewRequest
        );
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  const deleteReview = useCallback(
    async (query: any) => {
      setLoading(true);
      setError(null);
      try {
        const deleteReview: DeleteReviewsRequest = {
          reviewIds: query,
        };
        const response = await api.deleteReviews(deleteReview);
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  const addOrderReview= useCallback(
    async (addReviewRquest: AddReviewRequest) => {
      setLoading(true);
      setError(null);
      try {
        const response = await api.addOrderReview(addReviewRquest);
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );
  return {
   getAllItemReview,
   getToggleStatus,
   deleteReview,
   addOrderReview,
    loading,
    error,
    
  };
};
